import { render, staticRenderFns } from "./BlanksList.vue?vue&type=template&id=50ab153e&scoped=true&"
import script from "./BlanksList.vue?vue&type=script&lang=js&"
export * from "./BlanksList.vue?vue&type=script&lang=js&"
import style0 from "./BlanksList.vue?vue&type=style&index=0&id=50ab153e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ab153e",
  null
  
)

export default component.exports